export const localValidate = (formState) => {
  let errors = {};

  //Us Citizen
  if (formState.bgcFlag !== false && formState.bgcFlag !== true) {
    errors.bgcFlag = 'Must select yes or no for this field';
  }

  return errors;
};

const MemberBackgroundCheckFlagValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
}

export default MemberBackgroundCheckFlagValidation;